const API_BASE = process.env.REACT_APP_API_URL || '/api';
const API_ROOT = API_BASE.endsWith('/api') ? API_BASE.slice(0, -4) || '' : API_BASE;
const ADMIN_PASSWORD_KEY = 'knowit_admin_password';

function getAdminHeaders(extra = {}) {
  const password = localStorage.getItem(ADMIN_PASSWORD_KEY);
  if (!password) return extra;

  return {
    ...extra,
    'X-Admin-Password': password,
  };
}

/**
 * Submit a contact form enquiry.
 * POST /api/contact
 */
export async function submitContact(data) {
  const response = await fetch(`${API_BASE}/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: data.name,
      email: data.email,
      company: data.company || null,
      message: data.message,
    }),
  });

  const result = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(result?.message || `Request failed (${response.status})`);
  }

  return result;
}

/**
 * Check API health.
 * GET /api/status
 */
export async function getStatus() {
  const response = await fetch(`${API_BASE}/status`);
  if (!response.ok) throw new Error('API unavailable');
  return response.json();
}

export async function getEnabledPages() {
  const response = await fetch(`${API_ROOT}/api/pages`);
  if (!response.ok) throw new Error('Failed to load page configuration');
  return response.json();
}

export async function getAdminPages() {
  const response = await fetch(`${API_ROOT}/api/admin/pages`, {
    headers: getAdminHeaders(),
  });
  if (response.status === 401) throw new Error('Unauthorized. Please enter the admin password.');
  if (!response.ok) throw new Error('Failed to load admin page configuration');
  return response.json();
}

export async function updateAdminPage(pageKey, payload) {
  const response = await fetch(`${API_ROOT}/api/admin/pages/${pageKey}`, {
    method: 'PUT',
    headers: getAdminHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(payload),
  });

  const result = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(result?.message || `Update failed (${response.status})`);
  }

  return result;
}

export async function adminLogin(password) {
  const response = await fetch(`${API_ROOT}/api/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });

  const result = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(result?.message || 'Invalid admin password');
  }

  localStorage.setItem(ADMIN_PASSWORD_KEY, password);
  return result;
}

export function clearAdminSession() {
  localStorage.removeItem(ADMIN_PASSWORD_KEY);
}

export function hasAdminSession() {
  return Boolean(localStorage.getItem(ADMIN_PASSWORD_KEY));
}

export async function getSiteConfig() {
  const response = await fetch(`${API_ROOT}/api/site-config`);
  if (!response.ok) throw new Error('Failed to load site configuration');
  return response.json();
}

export async function getAdminSiteConfig() {
  const response = await fetch(`${API_ROOT}/api/admin/site-config`, {
    headers: getAdminHeaders(),
  });

  if (response.status === 401) throw new Error('Unauthorized. Please enter the admin password.');
  if (!response.ok) throw new Error('Failed to load admin site configuration');
  return response.json();
}

export async function updateAdminSiteConfig(payload) {
  const response = await fetch(`${API_ROOT}/api/admin/site-config`, {
    method: 'PUT',
    headers: getAdminHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(payload),
  });

  const result = await response.json().catch(() => null);

  if (response.status === 401) throw new Error('Unauthorized. Please enter the admin password.');
  if (!response.ok) {
    throw new Error(result?.message || `Update failed (${response.status})`);
  }

  return result;
}
